export enum Route {
  Root = '/',
  Home = '/',
  MyActiveMatches = '/my-active-matches',
  GameSessions = '/game-sessions/:id',
  GameSessionsSpectate = '/game-sessions/:id/spectate',
  Games = '/games',
  EditGame = '/games/:id/edit',
  Game = '/games/:id',
  GameCreated = '/games/:id/created',
  NotFound = '/not-found',
  PlayersRoot = '/players/*',
  Players = '/players',
  PlayersOnline = '/players/online',
  PlayersRecentlyPlayed = '/players/recently-played',
  Player = '/players/:id',
  MyProfile = '/players/me',
  PlayerMyProfileEdit = '/players/me/edit',

  UserDetails = '/user-detail/:userId',
  TransactionHistory = '/transaction-history',
  PlatformLinking = '/platform-linking',

  ConnectionCallback = '/connection/:platformId/callback',

  // Admin
  AdminManageTournaments = '/admin/manage-tournaments',
  AdminManageUsers = '/admin/manage-users',
  AdminManageUser = '/admin/manage-users/:id',
  AdminWithdrawRequests = '/admin/withdraw-requests',
  AffiliatePrograms = '/affiliate-programs',
  AffiliateProgram = '/affiliate-programs/:id',
  ManageAffiliatePrograms = '/admin/affiliate-programs',
  ManageAffiliateProgram = '/admin/affiliate-programs/:id',

  // Tournaments
  CreateTournament = '/create-tournament',
  CreateTournamentSuccess = '/tournaments/:id/success',
  MyActiveTournaments = '/tournaments/active',
  MyPastTournaments = '/tournaments/past',
  TournamentSuccess = '/tournament-success',
  AdminTournamentSuccess = '/admin-tournament-success',

  Tournament = '/tournaments',
  TournamentRoot = '/tournaments/:id/*',
  TournamentEdit = '/tournaments/:id/edit',
  TournamentOverview = '/tournaments/:id/overview',
  TournamentBracket = '/tournaments/:id/bracket',
  TournamentBracketFullScreen = '/tournaments/:id/bracket/full-screen',
  TournamentMyTeam = '/tournaments/:id/my-team',
  TournamentTeams = '/tournaments/:id/teams',
  TournamentPrizes = '/tournaments/:id/prizes',
  TournamentAdmin = '/tournaments/:id/admin',
  ManageTournamentDetails = '/manage-tournament-detail/:tournamentId',

  // Payments
  PaymentBalance = '/payments/balance',
  PaymentTransactions = '/payments/transactions',

  // Game Statistics
  GameStatistics = '/game-statistics/:id',
}
